import { defineMessages } from 'react-intl';

export const extendedBreadcrumbsMessages = defineMessages({
  backToSERP: {
    defaultMessage: 'Zurück zum Suchergebnis',
    id: 'breadcrumb.button.back-to-serp',
  },
  backToMBA: {
    defaultMessage: 'Zurück',
    id: 'breadcrumb.button.back-to-mba',
  },
  backToLastCategory: {
    defaultMessage: 'Zurück zu',
    id: 'breadcrumb.button.back-to-last-category',
  },
});
